<template>
  <div>
    <b-card class="rounded-xl">
      <div class="flex justify-between items-center mobile-flexnone">
        <div>
          <h2 class="text-2xl font-semibold">
            Logo Customization
          </h2>
        </div>
      </div>
      <div class="flex mt-10 justify-between items-center mobile-flexnone">
        <div class="cust-wid45 shadow-xl">
          <b-card>
            <div class="">
              <img
                v-if="renderedLogo"
                :src="renderedLogo"
                class="cust-h250 w-full object-contain"
              />
              <img v-else :src="logo" class="cust-h250 w-full object-contain" />
            </div>
            <div class="cust-divider"></div>
            <div class="flex mt-8 items-center">
              <div class="w-3/4">
                <p class="font-medium text-xl">Upload Your Logo</p>
              </div>
              <div class="1/4">
                <input
                  ref="logoInput"
                  @change="handleLogoClick"
                  type="file"
                  accept="image/*"
                  class="hidden"
                />
                <base-button
                  v-if="!renderedLogo"
                  type="primary"
                  class="px-8"
                  @click="$refs.logoInput.click()"
                >
                  Upload
                </base-button>
                <div class="flex" v-else>
                  <base-button type="primary" class="px-8" @click="uploadLogo">
                    Save
                  </base-button>
                  <base-button
                    type="danger"
                    class="px-8"
                    @click="handleLogoRemove"
                  >
                    Remove
                  </base-button>
                </div>
              </div>
            </div>
          </b-card>
        </div>
        <div class="cust-wid45 shadow-xl">
          <b-card>
            <div>
              <img
                v-if="renderedFavicon"
                :src="renderedFavicon"
                class="cust-h250 w-full object-contain"
              />
              <img
                v-else
                :src="favicon"
                class="cust-h250 w-full object-contain"
              />
            </div>
            <div class="cust-divider"></div>
            <div class="flex mt-8 items-center">
              <div class="w-3/4">
                <p class="font-medium text-xl">Upload Your Favicon</p>
              </div>
              <div class="1/4">
                <input
                  ref="faviconInput"
                  @change="handleFaviconClick"
                  type="file"
                  accept="image/*"
                  class="hidden"
                />
                <base-button
                  type="primary"
                  class="px-8"
                  @click="$refs.faviconInput.click()"
                  v-if="!renderedFavicon"
                >
                  Upload
                </base-button>
                <div class="flex" v-else>
                  <base-button
                    type="primary"
                    class="px-8"
                    @click="uploadFavicon"
                  >
                    Save
                  </base-button>
                  <base-button
                    type="danger"
                    class="px-8"
                    @click="handleFaviconRemove"
                  >
                    Remove
                  </base-button>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
      <div class="flex mt-10    mobile-flexnone">
        <div class="pr-8">
          <p class="font-semibold text-xl">
            Select your color scheme
          </p>
        </div>
        <div class="w-1/5 pr-4">
          <base-input type="color" v-model="primaryColorLocal" />
        </div>

        <div class="w-1/4 pr-4">
          <b-input
            placeholder="Hexcode"
            v-model="primaryColor"
            class="form-control-muted"
            disabled
          />
        </div>
        <div class="mobile-mt4">
          <base-button
            type="primary"
            class="px-8"
            @click.stop="editPrimaryColor"
          >
            Save Changes
          </base-button>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapState } from "vuex";

import brandingMixin from "@/mixins/branding";

export default {
  mixins: [brandingMixin],
  data() {
    return {
      renderedLogo: null,
      renderedFavicon: null,
      logoFile: null,
      faviconFile: null
    };
  },
  computed: {
    ...mapState("brand", {
      logo: "logo",
      favicon: "favicon",
      primaryColor: "primaryColor"
    }),
    primaryColorLocal: {
      get() {
        return this.primaryColor;
      },
      set(val) {
        this.$store.commit("brand/SET_BRAND_DETAIL", {
          key: "primaryColor",
          value: val
        });
        this.setColor(this.setPrimaryColor(val));
      }
    }
  },
  methods: {
    setColor(func, delay = 300) {
      let timeout;
      clearTimeout(timeout);

      timeout = setTimeout(func, delay);
    },
    setPrimaryColor(color) {
      const params = {
        colors: {
          primary: color
        }
      };
      const style = this.ApplyBranding(params);
      this.updateStyles(style);
    },
    handleLogoClick(e) {
      this.handleClick(e, "logoInput");
    },
    handleLogoRemove() {
      this.logoFile = null;
      this.renderedLogo = null;
    },
    handleFaviconClick(e) {
      this.handleClick(e, "faviconInput");
    },
    handleFaviconRemove() {
      this.favicomFile = null;
      this.renderedFavicon = null;
    },
    handleClick(e, ref) {
      const files = e.target.files;
      const rawFile = files[0];
      if (!rawFile) return;
      this.uploadImage(rawFile, ref);
    },
    uploadImage(file, ref) {
      this.$refs[ref].value = null; // fix can't select the same image
      this.loadImage(file, ref);
    },
    loadImage(image, ref) {
      if (ref == "logoInput") {
        this.logoFile = image;
      } else {
        this.faviconFile = image;
      }

      this.readerData(image, ref);
    },
    readerData(rawFile, ref) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = e => {
        // this.$emit("load", (this.renderedImage = e.target.result));
        if (ref == "logoInput") {
          this.renderedLogo = e.target.result;
        } else {
          this.renderedFavicon = e.target.result;
        }
        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async editPrimaryColor() {
      const payload = {
        primaryColor: this.primaryColorLocal
      };

      const loader = this.$loading();
      try {
        await this.$store.dispatch("brand/editClientDetails", payload);
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async uploadLogo() {
      const payload = new FormData();
      payload.append("logo", this.logoFile);

      const loader = this.$loading();
      try {
        const { data } = await this.$store.dispatch(
          "brand/uploadLogo",
          payload
        );

        this.$store.commit("brand/SET_BRAND_DETAIL", {
          key: "logo",
          value: `${this.$imageURL}/${data.logo}`
        });

        this.handleLogoRemove();
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async uploadFavicon() {
      const payload = new FormData();
      payload.append("favicon", this.faviconFile);

      const loader = this.$loading();
      try {
        const { data } = await this.$store.dispatch(
          "brand/uploadFavicon",
          payload
        );
        this.$store.commit("brand/SET_BRAND_DETAIL", {
          key: "favicon",
          value: `${this.$imageURL}/${data.favicon}`
        });
        this.setFavicon(`${this.$imageURL}/${data.favicon}`);
        this.handleFaviconRemove();
        loader.close();
      } catch (error) {
        loader.close();
      }
    }
  }
};
</script>

<style>
.cust-h250 {
  height: 250px;
}
.cust-wid45 {
  width: 45%;
}
</style>
